import styled from '@emotion/styled';
import { EmotionBreakpoint } from 'dw-us-ui';

const StyledFreeGiftSection = styled.div`
	display: flex;
	gap: 10px;
	align-items: center;
	width: 100%;
	${EmotionBreakpoint('mobile')} {
		padding: 0 24px;
	}
`;

const StyledFreeGiftContainer = styled.div`
	width: 100%;
	align-items: center;
	padding: 12px 24px;
	border: 1.5px solid #cf004f;
	border-radius: 8px;
	background: linear-gradient(
		90deg,
		rgb(255, 255, 255) 0%,
		rgb(255, 255, 255) 100%
	);
	.wsj & {
		border: 1.5px solid #e92440;
	}

	display: grid;
	grid-gap: 0px 24px;
	grid-template-columns: max-content auto;
	grid-template-rows: max-content auto;
	grid-template-areas:
		'one two'
		'one three';

	${EmotionBreakpoint('mobile')} {
		grid-template-columns: 1fr 1fr;
		grid-template-areas:
			'one two'
			'three three';
		grid-gap: 24px;
	}
`;

const StyledGiftImage = styled.div`
	grid-area: one;
	justify-self: flex-end;
`;

const StyledGiftContentContainer = styled.div`
	grid-area: three;
	align-self: flex-start;
`;

const StyledFreeGiftBadge = styled.div`
	grid-area: two;
	width: max-content;
	padding: 3px 10px;
	border-radius: 8px;
	background: #cf004f;

	.wsj & {
		background: #e92440;
	}

	@media (min-width: 768px) {
		align-self: end;
		margin-bottom: 10px;
	}
`;

const StyledBadgeText = styled.p`
	font-family: 'Roboto', sans-serif;
	font-weight: 700;
	font-size: 14px;
	line-height: 22px;
	color: #f9fafb;
	letter-spacing: 0.7px;
	text-transform: uppercase;
	margin: 0;
	.wsj & {
		font-family: Arial, sans-serif;
	}
`;

const StyledGiftDescription = styled.p`
	font-family: 'Roboto', sans-serif;
	font-weight: 400;
	font-size: 16px;
	line-height: 1.4;
	color: #000;
	margin: 0;
	text-align: left;

	.bold-text {
		font-weight: 700;
	}
	.wsj & {
		font-family: Arial, sans-serif;
	}
`;

const FreeGiftSection = ({ freeGiftUrl, freeGiftDescription }) => {
	return (
		<StyledFreeGiftSection>
			<StyledFreeGiftContainer>
				<StyledGiftImage>
					<img
						src={freeGiftUrl || '/images/us/common/default_bottle_small.png'}
						alt='Free gift'
						onError={(e) => {
							e.currentTarget.onerror = null;
							e.currentTarget.src =
								'/images/us/common/default_bottle_small.png';
						}}
					/>
				</StyledGiftImage>

				<StyledFreeGiftBadge>
					<StyledBadgeText>FREE GIFT</StyledBadgeText>
				</StyledFreeGiftBadge>

				<StyledGiftContentContainer>
					<StyledGiftDescription
						dangerouslySetInnerHTML={{
							__html: freeGiftDescription || '',
						}}
					></StyledGiftDescription>
				</StyledGiftContentContainer>
			</StyledFreeGiftContainer>
		</StyledFreeGiftSection>
	);
};

export default FreeGiftSection;
